import { RefereeEligibilities } from '~/pages/referee/components/referee-eligibilities';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Table } from '~/components/Table/Table';
import { JudgeSerializerGet } from '~/apis/ssf';
import { Fragment } from 'react/jsx-runtime';

interface Props {
  referee: JudgeSerializerGet;
}

export function RefereeBasicInfo({ referee }: Props) {
  return (
    <Fragment>
      <PageLayout.SubHeading>Generell information</PageLayout.SubHeading>

      <Table bg="odd">
        <Table.Body>
          <Table.Row>
            <Table.Col as="th">Licensnummer</Table.Col>
            <Table.Col>{referee.person.license_id}</Table.Col>
          </Table.Row>
          <Table.Row>
            <Table.Col as="th">Förening</Table.Col>
            <Table.Col>{referee.club.name}</Table.Col>
          </Table.Row>
          <Table.Row>
            <Table.Col as="th">Distrikt</Table.Col>
            <Table.Col>{referee.club.district.name}</Table.Col>
          </Table.Row>
          <Table.Row>
            <Table.Col as="th">Kategori</Table.Col>
            <Table.Col>
              <RefereeEligibilities referee={referee} />
            </Table.Col>
          </Table.Row>
        </Table.Body>
      </Table>
    </Fragment>
  );
}
